import { Component, OnInit } from '@angular/core';
import { EmailService } from '../services/email.service';
import { FormGroup, FormBuilder, FormControl, Validators, EmailValidator, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'mm-part11',
  templateUrl: './part11.component.html',
  styleUrls: ['./part11.component.scss']
})
export class Part11Component implements OnInit {
  readonly baseURL = './assets/images/part4/';
  gameTypes = ['משחק אינטרנטי בשידור מהאולפן', 'משחק טלפוני בשידור מהאולפן', 'משחק מרחוק בשידור מהאולפן', 'משחק משולב פיזי & ויראוטלי בהתאמה']
  detailsForm: FormGroup;

  constructor(private emailService: EmailService, private fb: FormBuilder) {
    this.detailsForm = this.fb.group({
      nvName: new FormControl(null, Validators.required),
      nvGameType: new FormControl(null, []),
      nvPhone: new FormControl(null, [Validators.pattern('^[0-9]*$'), Validators.minLength(9), Validators.maxLength(11), Validators.required]),
      nvEmail: new FormControl(null, [Validators.email, Validators.required]),
      nvMoreDetail: new FormControl(null),
    });
  }


  ngOnInit(): void {
  }

  getString(value: any) {
    return value ? value : '';
  }

  submitForm(formDirective: FormGroupDirective) {
    if (this.detailsForm.valid) {
      this.emailService.sendEmail(
        this.detailsForm.get('nvEmail').value,
        this.detailsForm.get('nvName').value,
        `הזמנת ${this.detailsForm.get('nvGameType').value ? this.detailsForm.get('nvGameType').value : 'אירוע'}`,
        `
        <strong>${this.detailsForm.get('nvName').value}</strong>
         מעוניין להזמין
         <strong>${this.detailsForm.get('nvGameType').value ? this.detailsForm.get('nvGameType').value : 'אירוע'}</strong><br>
       ליצירת קשר:<br>
        מייל - ${this.detailsForm.get('nvEmail').value}<br>
        טלפון - ${this.detailsForm.get('nvPhone').value}<br>
        <br>
        ${this.detailsForm.get('nvMoreDetail').value ?
          'הערות:<br>' +
          this.detailsForm.get('nvMoreDetail').value :
          ''}
        <br>
        <br>
        `)
        .then(res => {
          if (res) {
            console.log(res);
            const msg = `\n
            המייל נשלח בהצלחה!\n
            בקרוב יצרו איתך קשר מהמערכת להמשך ההזמנה`;
            alert(msg);
          } else {
            throw new Error('server error');
          }
        })
        .catch(err => {
          console.error(err);
          const msg = `\n
          אופס :( \n
          נראה שאירעה שגיאה במהלך שליחת המייל \n
          אנא נסה שוב מאוחר יותר`;
          alert(msg);
        })
        .finally(() => {
          formDirective.resetForm();
          this.detailsForm.reset();
          // stop waiting
        });
    }
  }
}
